


























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import MainHeader from "@/components/customer-header.vue";
import Fankui from "@/components/fankui.vue";

@Component({
  components: {
    MainHeader,
    Fankui,
  },
})
export default class Resources extends Vue {
  private showFankui: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private openFankui() {
    this.showFankui = true;
  }
}
